import React, { useState, useEffect } from "react"
import { FooterLinksDiv } from "./globalStyles"
import FooterLinks from "./footerLinks"
import windowDimensions from "../util/windowDimensions"

const Footer = () => {
  const { height, width } = windowDimensions()

  return (
    <footer
      style={{
        height: "250px",
        padding: "40px",
        background: "#060c21",

        // borderTop: "5px solid black",
      }}
    >
      {width > 1300 && (
        <div
          style={{
            position: "absolute",
            float: "left",
            width: "300px",
            fontWeight: "bold",
          }}
        >
          I'm a computer science student graduating at the end of 2021, working
          on full stack projects{" "}
        </div>
      )}

      <div className="mail">
        <div>
          <h1>Interested in doing a project together?</h1>
          <br />
          <a
            href="mailto: haldolaay@gmail.com"
            style={{
              textDecoration: "none",
              background: "inherit",
              color: "white",
              border: "2px solid white",
              fontWeight: "bold",
              padding: "5px",
              margin: "15px",
            }}
          >
            Contact Me{" "}
          </a>
        </div>
        {width > 800 && (
          <FooterLinksDiv>
            <FooterLinks />
          </FooterLinksDiv>
        )}
        <br />
        {/* {width > 600 && (
          <div style = {{position: "absolute", bottom:"5px"}}>
            <span >©{new Date().getFullYear()} Hamzah Aldolaay</span>
          </div>
        )} */}
      </div>
    </footer>
  )
}
export default Footer
